module.exports = __webpack_public_path__ + "media/images/icons/cloudy-6aafdfe06aab56e3d1630922d63821a5.svg";